import React from "react";
import { NavLink } from "react-router-dom";
import {
  useDeleteMediaMutation,
  useGetAllMediaQuery,
} from "../../redux/mediaApi";
import ImageCard from "./imageCard";
import { showErrorToast } from "../../utils/Utils";
import { toast } from "react-toastify";
import { showConfirmDialog } from "../showConfirmDialog/ShowConfirmDialog";

export const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + "...";
};

const Media = () => {
  const { data, error, isLoading } = useGetAllMediaQuery();
  const [deleteMedia, { isLoading: isDeleteLoading }] =
    useDeleteMediaMutation();
  const getVideoId = (url) => {
    const withoutPrefix = url.replace("https://youtu.be/", "");
    return withoutPrefix;
  };

  const handleDeleteMedia = async (id) => {
    try {
      const response = await deleteMedia(id).unwrap();
      if (response.success) {
        toast.success(response.message);
      }
    } catch (err) {
      console.error("media error:", err);
      showErrorToast(err);
    }
  };

  const handleDeleteConfrim = (id) => {
    showConfirmDialog({
      title: "Delete Media",
      message: "Are you sure you want to delete this Media?",
      type: "danger",
      onConfirm: () => {
        handleDeleteMedia(id);
      },
    });
  };

  const loading = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return (
    <div className="flex flex-col lg:gap-10 md:gap-6 gap-4 bg-white rounded-xl lg:p-4 p-3 h-full">
      <div className="flex justify-between items-center">
        <p className="text-[#05004E] font-semibold lg:text-[1.8rem] md:text-[1.4rem] text-[1.2rem]">
          Media
        </p>
        <div className="flex  items-center">
          <NavLink
            to={"/media/add-media"}
            className="lg:w-[12rem] md:w-[10rem] w-max bg-[#00643b] text-center lg:py-3 md:py-2 md:px-0 px-2 py-1.5 lg:text-[1rem] md:text-[.9rem] text-[.75rem] md:rounded-xl rounded-lg font-medium text-white"
          >
            + Add New
          </NavLink>
        </div>
      </div>
      {isLoading ? (
        <div className="flex flex-col lg:gap-10 md:gap-6 gap-4  w-full">
          <div className="relative aspect-video w-full bg-[#EFEFEF] animate-pulse rounded-2xl"></div>
          <div className=" grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-3 gap-2">
            {loading.map((i) => (
              <div
                key={i}
                className="bg-[#EFEFEF] w-full  relative aspect-[3/2] rounded-xl animate-pulse"
              >
                <div className="absolute bottom-5 bg-[#97979750] rounded-lg z-20 w-[95%] mx-[2.5%] h-6"></div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        data && (
          <div className="flex flex-col lg:gap-10 md:gap-6 gap-4 w-full">
            <div className="  grid lg:grid-cols-2 grid-cols-1 gap-5 w-full">
              {data?.video?.map((vid, i) => (
                <div
                  key={i}
                  className=" relative w-full flex flex-col gap-2 bg-[#efefef] md:p-4 p-2 rounded-xl"
                >
                  <div className="relative aspect-video w-full ">
                    <iframe
                      className="absolute top-0 left-0 w-full h-full rounded-xl"
                      src={`https://www.youtube.com/embed/${getVideoId(
                        vid?.youtubeVideo
                      )}&amp;controls=0`}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  </div>
                  <div className=" absolute z-10 flex bg-[#efefef] md:top-4 md:right-4 top-2 right-2 md:p-3 p-1.5 rounded-es-xl justify-end items-center md:gap-2 gap-1">
                    <NavLink
                      to={`/media/update-media/${vid?._id}`}
                      className={`capitalize md:w-[5rem]  w-[3rem] bg-blue-500 text-center text-white md:text-sm text-[11px] font-medium md:py-2 py-1 rounded-lg hover:bg-blue-800`}
                    >
                      edit
                    </NavLink>{" "}
                    <button
                      onClick={() => handleDeleteConfrim(vid?._id)}
                      disabled={isDeleteLoading ? true : false}
                      className={`capitalizemd: md:w-[5rem] w-[3rem]  bg-red-500 text-center text-white md:text-sm text-[11px] font-medium md:py-2 py-1 rounded-lg hover:bg-red-800`}
                    >
                      Delete
                    </button>{" "}
                  </div>
                </div>
              ))}
            </div>
            <div className=" grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-3 gap-2">
              {data?.image?.map((image) => (
                <div
                  key={image?._id}
                  className=" relative w-full flex  bg-[#efefef] lg:p-3 p-2 rounded-xl"
                >
                  <ImageCard image={image} />
                  <div className=" absolute lg:top-3 lg:right-3 top-2 right-2 lg:p-2 p-1.5 rounded-es-xl bg-[#efefef] z-10 flex justify-end items-center lg:gap-2 gap-1">
                    <NavLink
                      to={`/media/update-media/${image?._id}`}
                      className={`capitalize lg:w-[4rem] w-[3rem]  bg-blue-500 text-center text-white lg:text-sm text-[11px] font-medium lg:py-2 py-1 rounded-lg hover:bg-blue-800`}
                    >
                      edit
                    </NavLink>{" "}
                    <button
                      onClick={() => handleDeleteConfrim(image?._id)}
                      disabled={isDeleteLoading ? true : false}
                      className={`capitalize lg:w-[4rem] w-[3rem]  bg-red-500 text-center text-white lg:text-sm text-[11px] font-medium lg:py-2 py-1 rounded-lg hover:bg-red-800`}
                    >
                      Delete
                    </button>{" "}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )
      )}
      {error && (
        <p className=" text-red-500 text-center md:text-[1rem] text-sm bg-red-100 p-2 rounded-lg">
          {error?.data?.message}
        </p>
      )}
    </div>
  );
};

export default Media;
